























































































































































































import Vue from 'vue'
import Component from 'vue-class-component'
import DatePicker from './DatePicker.vue'
import TimePicker from './TimePicker.vue'
import { Prop, Watch, Ref } from 'vue-property-decorator'
import LocationPicker from './LocationPicker.vue'
import { CrudFieldType, CrudFormField } from '@/utils/types'
import { uploadImage } from '@/utils/helpers'

@Component({ components: { LocationPicker, DatePicker, TimePicker } })
export default class CrudForm extends Vue {
  @Prop(String) title!: string
  @Prop(Boolean) fullscreen?: boolean
  @Prop(Boolean) isLoading?: boolean
  @Prop(Array) fields?: CrudFormField[]
  @Ref('form') form!: { validate: () => boolean }
  FieldType = CrudFieldType
  fieldModels: CrudFormField[] = []
  showPass = false
  valid = false

  @Watch('fields')
  onFieldsChanged (fields: CrudFormField[]) {
    this.fieldModels = fields
  }

  emitClose () {
    this.$emit('close')
  }

  validate () {
    this.valid = this.form.validate?.()
  }

  mounted () {
    this.fieldModels = this.fields || []
  }

  getFileFromUrl (url: string): File | undefined {
    if (!url) {
      return undefined
    }
    return new File([], url, {})
  }

  async onFileChange (file: File, field: CrudFormField) {
    if (!file?.size) return

    field.isLoading = true
    field.value = ''
    field.value = await uploadImage(file)
    field.isLoading = false
  }

  clearFile (field: CrudFormField) {
    field.value = ''
  }

  handleInput<T> (field: CrudFormField<T>, value: T) {
    field.value = value
    field.handleValueChanged && field.handleValueChanged(value)
  }

  async submitIfValid () {
    this.validate()
    if (!this.valid) return
    const fields = this.fieldModels.filter(field => !field.isDisplayOnly)
    this.$emit('submit', fields)
  }
}
